<template>
  <div>
    <b-row>
      <!-- Map🚀 -->

      <b-col lg="12">
        <template>
          <b-card-code style="background-color:rgba(255,255,255, 0.9);">
            <b-row>
              <b-col
                md="3"
                class="d-flex align-items-center justify-content-start mb-1"
              >
                <label>Search</label>
                <b-input-group
                  size="sm"
                  style="padding-left:14px;"
                >
                  <b-form-input
                    id="filterInput"
                    v-model="filter"
                    type="search"
                    placeholder="Type to Search"
                    label-cols-sm="12"
                    label-cols-md="2"
                    label-cols-lg="2"
                    style="background-color:rgba(255,255,255, 0.9);"
                  />
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                    >
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col
                md="8"
                sm="12"
                lg="9"
                xs="12"
                class="text-sm-right mb-1"
              >
                <!-- <b-button
                  id="toggle-btn"
                  v-b-modal="'modalAdd'"
                  variant="primary"
                >
                  Add New
                </b-button> -->
              </b-col>
              <b-col cols="12">
                <b-table
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >

                  <template #cell(connect)="data">
                    <b-badge :variant="connect[1][data.value]">
                      {{ connect[0][data.value] }}
                    </b-badge>
                  </template>
                  <template #cell(status)="data">
                    <b-badge :variant="status[1][data.value]">
                      {{ status[0][data.value] }}
                    </b-badge>
                  </template>
                </b-table>
              </b-col>

              <b-col
                cols="12"
              >
                <b-card-body class="d-flex justify-content-between flex-wrap pt-1">

                  <!-- page length -->
                  <b-form-group
                    label="Per Page"
                    label-cols="6"
                    label-align="left"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="text-nowrap mb-md-0 mr-1"
                  >
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPage"
                      size="sm"
                      inline
                      :options="pageOptions"
                      style="background-color:rgba(255,255,255, 0.9);"
                    />
                  </b-form-group>

                  <!-- pagination -->
                  <div>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      first-number
                      last-number
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mb-0"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card-code>
          <DeviceEdit
            ref="childref"
            @fetch="getDeviceModel()"
          />
          <DeviceAdd
            @fetch="getDeviceModel()"
          />
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BRow, BCol, BTable, BFormGroup,
  BFormSelect, BPagination, BCardBody,
  BButton, BInputGroupAppend, BInputGroup, BFormInput, VBModal, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BCardBody,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BCardCode,
    BBadge,
    // StatisticCardHorizontal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      items: [],
      fields: [
        // { key: 'edit', label: 'Edit', class: 'text-center' },
        {
          key: 'devid', label: 'Devid', sortable: true, class: 'text-center',
        },
        {
          key: 'status', label: 'Status', sortable: true, class: 'text-center',
        },
        {
          key: 'devbuilding', label: 'Building', sortable: true, class: 'text-left',
        },
        {
          key: 'system_name', label: 'System Name', sortable: true, class: 'text-center',
        },
        {
          key: 'devdesc', label: 'Type', sortable: true, class: 'text-center',
        },
        {
          key: 'lastupdate', label: 'LastUpdate', sortable: true, class: 'text-center',
        },
        {
          key: 'connect', label: 'Connected', sortable: true, class: 'text-center',
        },
        // { key: 'delete', label: 'Delete', class: 'text-center' },
      ],
      Total: '',
      Online: '',
      Offline: '',
      // --------history--------
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      connect: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      status: [{
        AbNormal: 'AbNormal', Gen: 'Gen', Main: 'Main', OFF: 'OFF', Running: 'Running', Alarm: 'Alarm', Normal: 'Normal', Trip: 'Trip', ON: 'ON', ONLINE: 'ONLINE', OFFLINE: 'OFFLINE', EmergencyCall: 'Emergency Call',
      },
      {
        AbNormal: 'danger', Gen: 'info', Main: 'success', OFF: 'danger', Running: 'success', Alarm: 'danger', Normal: 'success', Trip: 'warning', ON: 'success', ONLINE: 'success', OFFLINE: 'danger', EmergencyCall: 'danger',
      }],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  created() {
    setInterval(() => {
      this.getDeviceModel()
    }, 7000)
  },
  mounted() {
    this.getDeviceModel()
  },
  methods: {
    getDeviceModel() {
      axios
        .get('/get_deviceNPT')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.table-responsive{
   font-size: 13px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
.vue2leaflet-map{
  &.leaflet-container{
    height: 325px;
  }
}
.leaflet-popup-content {
  margin: 10px 10px;
}
.leaflet-container a.leaflet-popup-close-button {
  padding: 0 0 0 0
}
</style>
